import React from "react";
import './SpecialFacility.css'; // Updated CSS file name

function SpecialFacilities() {
  return (
    <div className="stylesheetpage-container">
      <div className="stylesheetpage-box">
        <h2 className="stylesheetpage-title">Special Facilities</h2>

        <p className="stylesheetpage-text">
          The Academy has state of the art facilities such as three fully
          equipped science labs, two modern ICT labs and audio/visual Smart
          Boards in the classrooms. A qualified in-house student counselor is
          available for approach by parents and students. Our sport facilities
          are second to none including an indoor, heated swimming pool, a basket
          ball court, fully equipped gym and a functional football ground. The
          Academy provides fresh hot meals daily in the campus cafeteria.
        </p>
      </div>
    </div>
  );
}

export default SpecialFacilities;
